import { render } from "./VHelpWidget.vue?vue&type=template&id=74f12caf"
import script from "./VHelpWidget.vue?vue&type=script&lang=js"
export * from "./VHelpWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__